import React, {FC} from 'react';
import './Grid.scss';
import Cell from "../Cell/Cell";
import {Values} from "../../models/Game.model";

interface GridProps {
    onClick: (row: number, col: number) => void;
    values: Values;
}

const Grid: FC<GridProps> = (props: GridProps) => {
    const cellOnClick = (row: number, col: number) => () => props.onClick(row, col);

    return (
        <>
            {Array.from(Array(3), (_, row) => (
                Array.from(Array(3), (__, col) => (
                    <Cell key={row + "-" + col} onClick={cellOnClick(row, col)}
                          value={props.values[row * 3 + col]}/>
                ))
            ))}
        </>
    );
}

export default Grid;
